import { useState, useEffect } from "react";
import "./documents.css";
import { PiFile } from "react-icons/pi";
import { BsEyeFill } from "react-icons/bs";
import { SlClose } from "react-icons/sl";
import { useSelector } from "react-redux";
import NotFound from "../../../../ui/organisms/not-found/404";
import { isEmpty, wait } from "../../../../core/utils/helpers";
import Swal from "sweetalert2";
import {
  onGetTeamMemberDocuments,
  onDeleteTeamMemberDocuments,
} from "../../services/user";
import useAxiosPrivate from "../../../../app/providers/context-provider/useAxiosPrivate";

const Documents = () => {
  const axiosPrivate = useAxiosPrivate();

  const [documents, setDocuments] = useState(null);
  const [isRefresh, setIsRefresh] = useState(false);

  const [isReading, setIsReading] = useState(false);
  const [previewDocument, setPreviewDocument] = useState(null);

  const currentTeamMemberData = useSelector(
    (state) => state.setInitConf.currentTeamMemberData,
  );

  const currenTeamMemberId = currentTeamMemberData?.id;

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const signal = controller.signal;

    const localData = {
      curren_team_member_id: currenTeamMemberId,
    };

    onGetTeamMemberDocuments(axiosPrivate, localData, signal).then(
      (response) => {
        const _data = response?.data?.result;
        setDocuments(_data);
      },
    );

    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [isRefresh]);

  const onPreviewDocument = async (fileUrl) => {
    try {
      // Fetch the file from the server
      const response = await fetch(fileUrl);

      if (!response.ok) {
        throw new Error("Unable to fetch file from server");
      }

      // Convert to Blob
      const blob = await response.blob();

      // Check MIME type
      const mimeType = blob.type;
      const blobURL = URL.createObjectURL(blob);

      if (mimeType === "application/pdf") {
        // Show PDF inline
        setPreviewDocument(blobURL);
        setIsReading(true);
      } else if (
        mimeType === "application/msword" ||
        mimeType ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        // Open DOC/DOCX in new tab
        window.open(blobURL, "_blank");
      } else {
        alert("Preview not supported for this file type.");
      }
    } catch (error) {
      console.error("Error previewing document:", error);
      alert("Failed to preview document.");
    }
  };

  const onHandleDeleteDocuments = async (documentId, documentTitle) => {
    const result = await Swal.fire({
      title: "Document Deletion",
      text: `You are about to delete this document : ${documentTitle}. Do you really want to delete it?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, I do",
    });

    if (result.isConfirmed) {
      Swal.fire({
        title:
          '<span style="font-size:1rem; color:grey;">Deleting document...</span>',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,

        didOpen: () => {
          Swal.showLoading();
        },
      });

      // attendre 1.5 sec
      await wait(1500);

      // Delete document
      const response = await onDeleteTeamMemberDocuments(axiosPrivate, {
        document_id: documentId,
        document_title: documentTitle,
      });
      const _data = response?.data;

      if (_data?.status) {
        setIsRefresh(!isRefresh);
      }

      // fermer swal si nécessaire
      Swal.close();
    }
  };

  return isEmpty(documents) ? (
    <NotFound
      type={"data"}
      title={"No document found!"}
      text={"Team member does not have any document."}
      isBoutton={false}
    />
  ) : (
    <>
      <div className="u-d-documents">
        <div className="files-container">
          {documents?.map((document) => (
            <div className="file-item" key={document?.id}>
              <span className="icon-wrapper">
                <PiFile className="icon" />
              </span>
              <div className="file-description">
                <h1>{document?.thumbnail}</h1>
                <span>{document?.size}</span>
              </div>
              <div className="file-actions">
                <span
                  onClick={() =>
                    onPreviewDocument(
                      `${process.env.REACT_APP_API_SERVER_URL}:${process.env.REACT_APP_API_SERVER_PORT}/storage/documents/${document?.thumbnail}`,
                    )
                  }
                >
                  <BsEyeFill className="icon" />
                </span>
                <span
                  onClick={() =>
                    onHandleDeleteDocuments(document?.id, document?.thumbnail)
                  }
                >
                  <SlClose className="icon" />
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
      {isReading && (
        <div className="u-d-documents-preview">
          <div className="u-d-documents-preview-container">
            <span onClick={() => setIsReading(!isReading)}>Close</span>
            <iframe
              src={previewDocument}
              width="100%"
              height="95%"
              title="PDF Preview"
              style={{
                border: "1px solid #ccc",
                marginTop: "0.5rem",
                position: "relative",
              }}
            ></iframe>
          </div>
        </div>
      )}
    </>
  );
};

export default Documents;
